module.exports = __webpack_public_path__ + "img/featuredartist (1).8e41ead5.jpg";